module.exports = __webpack_public_path__ + "static/img/menu-bg-light.4aa1e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-bg-light.png
// module id = dobM
// module chunks = 2